import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import styles from './Navbar.module.css';

const NavBar = ({ defaultActive }) => {
  const [activePage, setActivePage] = useState(defaultActive || 'calendar');
  const navigate = useNavigate(); 

  useEffect(() => {
    setActivePage(defaultActive); // 매개변수에 따라 기본 활성화 설정
  }, [defaultActive]);

  const handleNavigation = (page) => {
    setActivePage(page);
    switch (page) {
      case 'quest':
        navigate('/questpage');
        break;
      case 'calendar':
        navigate('/main');
        break;
      case 'mypage':
        navigate('/mypage');
        break;
      default:
        break;
    }
  };

  return (
    <div className={styles.navbar}>
      <div
        className={`${styles.navButton} ${activePage === 'quest' ? styles.selected : ''}`}
        onClick={() => handleNavigation('quest')}
      >
        <div className={`${styles.questIcon} ${activePage !== 'quest' ? styles.inactiveIcon : ''}`} />
        {activePage === 'quest' && <span className={styles.navText}>퀘스트</span>}
      </div>

      <div
        className={`${styles.navButton} ${activePage === 'calendar' ? styles.selected : ''}`}
        onClick={() => handleNavigation('calendar')}
      >
        <div className={`${styles.calendarIcon} ${activePage !== 'calendar' ? styles.inactiveIcon : ''}`} />
        {activePage === 'calendar' && <span className={styles.navText}>캘린더</span>}
      </div>

      <div
        className={`${styles.navButton_MY} ${activePage === 'mypage' ? styles.selected : ''}`}
        onClick={() => handleNavigation('mypage')}
      >
        <div className={`${styles.userIcon} ${activePage !== 'mypage' ? styles.inactiveIcon : ''}`} />
        {activePage === 'mypage' && <span className={styles.navText}>마이페이지</span>}
      </div>
    </div>
  );
};

export default NavBar;
